<template>
  <div v-if="rsvp !== null" class="rsvp">
    <div class="rsvp-id">
      <a :href="'/#/reservation/' + rsvp.id" target="_blank">
        {{ $t('dispatch.mapDetails.reservation') }} {{ rsvp.id }}
      </a>
    </div>
    <div class="label-value">
      <div class="label">{{ $t('dispatch.mapDetails.pickup') }}</div>
      <div class="value">{{ getAddress(rsvp.pickup) }}</div>
    </div>
    <div class="label-value">
      <div class="label">{{ $t('dispatch.mapDetails.dropoff') }}</div>
      <div class="value">{{ getAddress(rsvp.dropoff) }}</div>
    </div>

    <div class="row">
      <div class="small-6 columns">
        <div class="label-value">
          <div class="label">{{ $t('dispatch.mapDetails.pickupTime') }}</div>
          <div class="value">{{ rsvp.pickupTime }}</div>
        </div>
      </div>
      <div class="small-6 columns">
        <div class="label-value">
          <div class="label">{{ $t('dispatch.mapDetails.flight') }}</div>
          <div class="value">
            <a href="javascript:;" v-if="rsvp.flight !== null" @click="showFlightInfo">{{ rsvp.flight }}</a>
            <span v-else>N/A</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="small-4 columns">
        <div class="label-value">
          <div class="label">{{ $t('dispatch.mapDetails.paxLuggage') }}</div>
          <div class="value">{{ rsvp.pax }}/{{ rsvp.luggage }}</div>
        </div>
      </div>
      <div class="small-4 columns">
        <div class="label-value">
          <div class="label">{{ $t('dispatch.mapDetails.serviceType') }}</div>
          <div v-bind:class="'value service-type ' + rsvp.serviceClass">{{ rsvp.serviceLabel }}</div>
        </div>
      </div>
      <div class="small-4 columns">
        <div class="label-value">
          <div class="label">{{ $t('dispatch.mapDetails.status') }}</div>
          <div v-bind:class="'value status ' + rsvp.statusClass">{{ rsvp.status }}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="small-4 columns">
        <div class="label-value">
          <div class="label">FARE AMOUNT</div>
          <div class="value">${{ rsvp.fare.toFixed(2) }}</div>
        </div>
      </div>
      <div class="small-4 columns">
        <div class="label-value">
          <div class="label">DRIVER PAYMENT</div>
          <div class="value">${{ getDriverPayment(rsvp.driverPayment).toFixed(2) }}</div>
          <a class="payment-breakdown-button" href="javascript:;"
            @click="showBreakdown(true)">See Payment Breakdown</a>
        </div>
      </div>
      <div class="small-4 columns">
        <div class="label-value">
          <div class="label">PICKUP TYPE</div>
          <div class="value">
            <span v-if="rsvp.pickup.geofenceType === 'airport'">
              {{ rsvp.meetAndGreet ? 'Meet &amp; Greet' : 'Curbside' }}
            </span>
            <span v-else>N/A</span>
          </div>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="label-value">
      <div class="label">{{ $t('dispatch.mapDetails.paxName') }}</div>
      <div class="value">
        <a :href="'/#/consumer/' + rsvp.customer.id" target="_blank">
          {{ rsvp.customer.firstName }} {{ rsvp.customer.lastName }}
        </a>
      </div>
    </div>

    <div class="row">
      <div class="small-4 columns">
        <div class="label-value">
          <div class="label">{{ $t('dispatch.mapDetails.paxPhone') }}</div>
          <div class="value"><a href="javascript:;" @click="callPhone(rsvp.customer)">{{ rsvp.customer.phone }}</a></div>
        </div>
      </div>
      <div class="small-8 columns">
        <div class="label-value">
          <div class="label">{{ $t('dispatch.mapDetails.paxEmail') }}</div>
          <div class="value">
            <a href="javascript:;" :href="'mailto:' + rsvp.customer.email">
              {{ rsvp.customer.email }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="label-value">
      <div class="label">{{ $t('dispatch.mapDetails.paxNote') }}</div>
      <div class="value">N/A</div>
    </div>

    <div class="divider"></div>
    <div v-if="rsvp.guest !== null">
      <div class="row">
        <div class="small-6 columns">
          <div class="label-value">
            <div class="label">{{ $t('dispatch.mapDetails.guestName') }}</div>
            <div class="value">{{ rsvp.guest.firstName }} {{ rsvp.guest.lastName }}</div>
          </div>
        </div>
        <div class="small-6 columns">
          <div class="label-value">
            <div class="label">{{ $t('dispatch.mapDetails.guestPhone') }}</div>
            <div class="value">
              <a href="javascript:;" v-if="rsvp.guest.phone !== ''" @click="callPhone(rsvp.guest)">{{ rsvp.guest.phone }}</a>
              <span v-else>N/A</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="label-value">
      <div class="label">{{ $t('dispatch.mapDetails.guestInfo') }}</div>
      <div class="value">
        <div class="info">{{ $t('dispatch.mapDetails.guestNone') }}</div>
        <!--a class="button cta xsmall warning" href="javascipt:;">
          {{ $t('dispatch.mapDetails.guestAdd') }}
        </a-->
      </div>
    </div>

    <!-- DRIVER INFO -->
    <div class="divider"></div>
    <div v-if="rsvp.driver !== null">
      <div class="row">
        <div class="small-6 columns">
          <div class="label-value">
            <div class="label">{{ $t('dispatch.mapDetails.driverName') }}</div>
            <div class="value">
              <a href="javascript:;" :href="'/#/provider/' + rsvp.driver.id" target="_blank" >
                {{ rsvp.driver.firstName }} {{ rsvp.driver.lastName }}
              </a>
            </div>
          </div>
        </div>
        <div class="small-6 columns">
          <div class="label-value">
            <div class="label">{{ $t('dispatch.mapDetails.driverEmail') }}</div>
            <div class="value">
              <a href="javascript:;" :href="'mailto:' + rsvp.driver.email">
                {{ rsvp.driver.email }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="label-value">
        <div class="label">{{ $t('dispatch.mapDetails.driverInfo') }}</div>
        <div class="value">
          <div class="info">{{ $t('dispatch.mapDetails.driverNone') }}</div>
        </div>
      </div>
    </div>
    <!-- DRIVER INFO end -->

    <!-- PAYMENT BREAKDOWN -->
    <div v-bind:class="{ 'modal-container': true, show: showPaymentBreakdown }" @click="showBreakdown(false)">
      <div class="modal">
        <div class="modal-content">
          <div class="payment-breakdown" @click.stop>
            <a class="close" href="javascript:;" @click="showBreakdown(false)">
              <i class="far fa-times-circle fa-fw"></i>
            </a>
            <div class="title">PAYMENT BREAKDOWN</div>
            <div class="row breakdown">
              <div class="small-6 columns label">Fare Amount:</div>
              <div class="small-6 columns value">${{ rsvp.driverPayment.base.toFixed(2) }}</div>
            </div>
            <div class="row breakdown">
              <div class="small-6 columns label">Bonus:</div>
              <div class="small-6 columns value">${{ rsvp.driverPayment.bonus.toFixed(2) }}</div>
            </div>
            <div class="row breakdown">
              <div class="small-6 columns label">Tip:</div>
              <div class="small-6 columns value">${{ rsvp.driverPayment.tip.toFixed(2) }}</div>
            </div>
            <div class="row breakdown">
              <div class="small-6 columns label">Pickup Fee:</div>
              <div class="small-6 columns value">${{ rsvp.driverPayment.pickupFee.toFixed(2) }}</div>
            </div>
            <div class="row breakdown total">
              <div class="small-6 columns label">Total:</div>
              <div class="small-6 columns value">${{ getDriverPayment(rsvp.driverPayment).toFixed(2) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- PAYMENT BREAKDOWN end -->

  </div>
</template>

<script>
import ApiFlightInfo from '@/modules/api/flight-info'
export default {
  name: 'dispatch-reservation-details',
  props: [ 'rsvp' ],
  data () {
    return {
      showPaymentBreakdown: false
    }
  },
  methods: {
    getAddress (location) {
      if (location.geofenceType === 'airport' &&
          location.geofenceName !== '') {
        let result = location.geofenceName
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal
        }
        return result
      }
      return location.title

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    getDriverPayment (breakdown) {
      return breakdown.base + breakdown.bonus + breakdown.tip + breakdown.pickupFee
    },
    showBreakdown (value) { this.showPaymentBreakdown = value },
    callPhone (contact) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: contact.phone,
        name: contact.firstName + ' ' + contact.lastName
      })
    },
    showFlightInfo () {
      let self = this
      ApiFlightInfo.loadFlightInfo(self, self.rsvp, r => {
        if (r.error) {
          console.log(r)
          return
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';
@import '../../assets/scss/_service-types';
.rsvp{
  padding: 0 20px 20px;

  & .rsvp-id{
    font-size: 22px;
    font-weight: 700;
    margin-top: 20px;
    margin-bottom: 20px;

    & a{ color: #3F2975; }
  }
}

.label-value{
  margin-top: 10px;
  & .label{
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 0;
    color: #8DA0A9;
  }

  & .value{
    color: #333;

    &.service-type{ color: #fff; }
    &.status{ color: #fff; font-size: 16px; }

    & .info {
      font-weight: 700;
      margin-top: 5px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
}

a{
  font-weight: 700;
}

.divider{
  display: block;
  width: 350px;
  margin: 20px auto;
  border-top: 1px solid rgba(0,0,0,0.2);
}

a.payment-breakdown-button {
  font-size: 10px;
  display: block;
}

.modal-container {
  position: fixed;
  top: -100%; left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.4);
  opacity: 0;
  transition: all 250ms;

  &.show {
    opacity: 1;
    top: 0;
  }

  & .modal {
    display: table;
    width: 100%;
    height: 100%;
  }

  & .modal-content {
    display: table-cell;
    vertical-align: middle;
  }
}

.payment-breakdown {
  width: 300px;
  background-color: #fff;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  overflow: hidden;
  position: relative;

  & .close {
    display: block;
    position: absolute;
    color: #fff;
    top: 0;
    right: 0;
    padding: 10px 10px;
  }

  & .title {
    background-color: #333;
    color: #fff;
    font-weight: 700;
    text-align: center;
    padding: 10px 5px;
  }

  & .breakdown {
    padding: 5px 15px;
    font-size: 14px;
    text-transform: uppercase;

    &.total{
      font-size: 16px;
      padding: 10px 0 10px;
      margin: 0 15px;
      border-top: 1px solid rgba(0,0,0,0.15);
    }
  }
  & .label {
    text-align: left;
    color: #555;
  }
  & .value {
    text-align: right;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/ReservationDetails.vue